import {
  bankTransferPayment,
  creditCard,
  sinpePayment,
} from 'src/constants/paymentTypes';

const packageOptions = {
  premium: 3,
  economy: 2,
  flexible: 1,
};

export enum EnumTypeOfQuotation {
  old = 'old',
  current = 'current',
  new = 'new',
}
interface ITypeOfQuotation {
  titles: string[];
  packageOptions?: Record<number, string[]>;
}

const dateStartNewQuotation = process.env
  .REACT_APP_DATE_START_NEW_QUOTATION as string;
const dateEndNewQuotation = process.env
  .REACT_APP_DATE_END_NEW_QUOTATION as string;
const coverages = ['0004', '0005'];

export const typeOfQuotation: Record<EnumTypeOfQuotation, ITypeOfQuotation> = {
  [EnumTypeOfQuotation.old]: {
    titles: ['Plan Premium', 'Plan Economy', 'Plan Flexible'],
    packageOptions: {
      [packageOptions.flexible]: coverages,
      [packageOptions.economy]: [...coverages, '0002'],
    },
  },
  [EnumTypeOfQuotation.current]: {
    titles: ['Plan Platino', 'Plan Dorado', 'Plan Económico'],
    packageOptions: {
      [packageOptions.flexible]: coverages,
    },
  },
  [EnumTypeOfQuotation.new]: {
    titles: ['Plan Platino', 'Plan Dorado', 'Plan Económico'],
  },
};

export const getTypeOfQuotation = (createdAt?: string): EnumTypeOfQuotation => {
  const startNow = new Date(dateStartNewQuotation).getTime();
  const endNow = new Date(dateEndNewQuotation).getTime();
  const dateCreated = new Date(createdAt ?? new Date()).getTime();
  if (dateCreated < startNow) {
    return EnumTypeOfQuotation.old;
  }
  if (dateCreated > startNow && dateCreated < endNow) {
    return EnumTypeOfQuotation.current;
  }
  return EnumTypeOfQuotation.new;
};

interface ChipPlan {
  title: string;
  colorText: string;
  colorBackground: string;
}

export function getChipPlanByOption(option: number): ChipPlan {
  if (option === packageOptions.premium) {
    return {
      title: 'Máxima protección',
      colorText: '#0C472C',
      colorBackground: '#E8FBF3',
    };
  }
  if (option === packageOptions.economy) {
    return {
      title: 'Beneficios básicos',
      colorText: '#623601',
      colorBackground: '#FFEFD0',
    };
  }
  return {
    title: 'Coberturas a tu medida',
    colorText: '#4A4B4E',
    colorBackground: '#EAEAEA',
  };
}

export function getAltImageByOption(option: number): string {
  if (option === packageOptions.premium) {
    return 'option premium logo';
  }
  if (option === packageOptions.economy) {
    return 'option economic logo';
  }
  return 'option flexible logo';
}

export function getOptionName(option: number, createdAt?: string): string {
  const newQuotation = getTypeOfQuotation(createdAt);
  const { titles } = typeOfQuotation[newQuotation];
  if (option === packageOptions.premium) {
    return titles[0];
  }
  if (option === packageOptions.economy) {
    return titles[1];
  }
  return titles[2];
}

export function getPaymentTypeName(type: string): string {
  if (type === creditCard) {
    return 'Card';
  }

  if (type === bankTransferPayment) {
    return 'BankTransfer';
  }

  if (type === sinpePayment) {
    return 'SinpeTransfer';
  }

  return '';
}

export function isPremiumOption(option: number): boolean {
  return option === packageOptions.premium;
}

export function getIndexFromPackageOption(option: number): number {
  if (option === packageOptions.premium) {
    return 0;
  }
  if (option === packageOptions.economy) {
    return 1;
  }
  return 2;
}
